import {MenuItem} from "../../Types/Layout/SidebarType";
import { currentSalesRole } from "../../Reports/reportsApi";


export const MenuList: MenuItem[] = [
  {
title: "",    
    lanClass: "lan-1",
    Items: [
      {
        title: "Profiles",
        icon: "fa-user",
        type: "sub",
        lanClass: "lan-3",
        children: [
          {
            title:"Teacher",
            path:`${process.env.PUBLIC_URL}/pages/teacher-profile`,
            type:"link"
          },
          {
            title:"Student",
            path:`${process.env.PUBLIC_URL}/pages/student-profile`,
            type:"link"
          }
        ]
      },
      {
            title: "Consumer Xperience",
            icon: "fa-heart-o",
            type: "sub",
            children: [
              {
                // Everything for relationship managers, in one group.
                // SidebarMenuList hides the whole group while RM_TASKS_ENABLED is off,
                // and Menulist shows the leader-only entries to team leads only —
                // both match these titles.
                title: "RM",
                type: "sub",
                active: false,
                children: [
                  { title: "Dashboard", path: `${process.env.PUBLIC_URL}/pages/rm-dashboard`, type: "link" },
                  { title: "My Students", path: `${process.env.PUBLIC_URL}/pages/rm-learners`, type: "link" },
                  { title: "Renewals", path: `${process.env.PUBLIC_URL}/pages/rm-renewals`, type: "link" },
                  { title: "Renewal Insights", path: `${process.env.PUBLIC_URL}/pages/renewal-insights`, type: "link" },
                  { title: "Task Insights", path: `${process.env.PUBLIC_URL}/pages/task-insights`, type: "link" },
                  { title: "Tasks", path: `${process.env.PUBLIC_URL}/pages/rm-tasks`, type: "link" },
                  { title: "Team Performance", path: `${process.env.PUBLIC_URL}/pages/rm-team-performance`, type: "link" },
                  { title: "Relationship Managers", path: `${process.env.PUBLIC_URL}/pages/rm-agents`, type: "link" },
                  { title: "Task Settings", path: `${process.env.PUBLIC_URL}/pages/rm-task-settings`, type: "link" },
                  { title: "Leaves", path: `${process.env.PUBLIC_URL}/pages/rm-leaves`, type: "link" },
                  { title: "Pods", path: `${process.env.PUBLIC_URL}/pages/rm-pods`, type: "link" },
                ],
              },
              {
                title:"Teacher Change",
                path:`${process.env.PUBLIC_URL}/pages/teacher-change`,
                type:"link"
              },
              {
                title:"Refund",
                path:`${process.env.PUBLIC_URL}/pages/refund`,
                type:"link"
              },
              {
                title:"Referral",
                path:`${process.env.PUBLIC_URL}/pages/referral`,
                type:"link"
              },
            ]
          },
      {
        title: "Teacher Operations",
        icon: "fa-id-badge",
        // icon: "support-tickets",
        type: "sub",
        children: [
          {
            title:"Teacher Compensation",
            path:`${process.env.PUBLIC_URL}/pages/teacher-compensation`,
            type:"link"
          },
          {
            title:"Leave Request",
            path:`${process.env.PUBLIC_URL}/pages/teacher-leave`,
            type:"link"
          },
          {
            title:"Slots Available",
            path:`${process.env.PUBLIC_URL}/pages/teacher-slots-available`,
            type:"link"
          },
          {
            title:"Teacher Payout",
            path:`${process.env.PUBLIC_URL}/pages/teacher-payout`,
            type:"link"
          },
          {
            title:"Teacher Ledger",
            path:`${process.env.PUBLIC_URL}/pages/teacher-ledger`,
            type:"link"
          },
          {
            title:"Teacher Escalation",
            path:`${process.env.PUBLIC_URL}/pages/teacher-escalation`,
            type:"link"
          },
          {
            title:"Teacher Reports",
            path:`${process.env.PUBLIC_URL}/pages/admin-teacher-reports`,
            type:"link"
          },
          {
            title:"Teacher Leader",
            path:`${process.env.PUBLIC_URL}/pages/teacher-leader`,
            type:"link"
          },
            {
              title:"RNR",
              path:`${process.env.PUBLIC_URL}/pages/rnr`,
              type:"link"
            },
          {
            title:"Class Correction",
            path:`${process.env.PUBLIC_URL}/pages/class-correction`,
            type:"link"
          },
         
        ]
      },
      {
        title: "Academics",
        icon: "fa-graduation-cap",
        type: "sub",
        children: [
          {
            title: "Video Call QA",
            path: `${process.env.PUBLIC_URL}/pages/video-call-qa`,
            type: "link",
          },
          {
            title: "QA Experiments & Settings",
            path: `${process.env.PUBLIC_URL}/pages/video-call-qa/experiments`,
            type: "link",
          },
          {
            title: "QA Parameters & Prompts",
            path: `${process.env.PUBLIC_URL}/pages/video-call-qa/parameters`,
            type: "link",
          },
          {
            title: "Teacher Recruitment",
            path: `${process.env.PUBLIC_URL}/pages/teacher-hiring`,
            type: "link",
          },
          {
            title: "Hiring Settings",
            path: `${process.env.PUBLIC_URL}/pages/teacher-hiring/settings`,
            type: "link",
          },
        ],
      },
      // { title : "Operations",
      //   type: "sub",
      //   children: [
      //     {
      //       title: "Demo Operations",
      //       path: `${process.env.PUBLIC_URL}/DemoOps`,
      //       type: "link"
      //     },

      //   ]
      // },
      
        
          {
            title:"Community",
            icon: "fa-users",
            type:"sub",
            active: false,
            children:[
              {
                title:"Community Ops",
                lanClass: "lan-4",
                path:`${process.env.PUBLIC_URL}/pages/community-ops`,
                type:"link"
              },
              {
                title:"Community Events",
                lanClass: "lan-4",
                path:`${process.env.PUBLIC_URL}/pages/event-count`,
                type:"link"
              },
            ]
          },
         
      { title : "Demo Ops",
        icon: "fa-desktop",
        type: "sub",
        children: [
          {
            title: "Demo Operations",
            path: `${process.env.PUBLIC_URL}/DemoOps`,
            type: "link"
          },
          {
            title:"Demo Shifts",
            lanClass: "lan-3",
            path:`${process.env.PUBLIC_URL}/pages/demo-shifts`,
            type:"link"
          },
          {
            title: "Demo Shift Active",
            path: `${process.env.PUBLIC_URL}/pages/demo-shift-active`,
            type: "link"
          },
          {
            title: "AE Reports",
            type: "sub",
            active: false,
            children: [
              {
                title: "Airline Slot Search",
                path: `${process.env.PUBLIC_URL}/pages/ae-reports/airline-slot-search`,
                type: "link",
              },
              {
                title: "Demo Status",
                path: `${process.env.PUBLIC_URL}/pages/ae-reports/demo-status-details`,
                type: "link",
              },
              {
                title: "AE slots",
                path: `${process.env.PUBLIC_URL}/pages/ae-reports/category-wise-ae-details`,
                type: "link",
              },
              {
                title: "AE Conversion",
                path: `${process.env.PUBLIC_URL}/pages/ae-reports/ae-conversion-details`,
                type: "link",
              },
              {
                title: "Slot Analysis",
                path: `${process.env.PUBLIC_URL}/pages/slot-analysis`,
                type: "link"
              }
            ],
          },
        ]
      },
      
      
          
          {
            title: "Offline",
            icon: "fa-map-marker",
            // icon: "support-tickets",
            type: "sub",
            children: [
              {
                title:"Batch Management",
                path:`${process.env.PUBLIC_URL}/pages/offline-batch`,
                type:"link"
              },
              {
                title:"Student List",
                path:`${process.env.PUBLIC_URL}/pages/offline-student`,
                type:"link"
              },
              {
                title:"Add Class",
                path:`${process.env.PUBLIC_URL}/pages/add-class`,
                type:"link"
              },
              {
                title:"Subscription Renewals",
                lanClass: "lan-3",
                path:`${process.env.PUBLIC_URL}/pages/subscription-renewals`,
                type:"link"
              },
            ]
          },

            //     // {
            //     //   title:"LMS",
            //     //   path:`${process.env.PUBLIC_URL}/pages/CourseList`,
            //     //   type:"link"
            //     // },
            //   ]
            // },

            // {
            //     title: "Teacher Change",
            //     lanClass: "lan-3",
            //     path: `${process.env.PUBLIC_URL}/pages/teacher-change`,
            //     type: "link"
            // },
          

            {
            title: "Marketing",
            icon: "fa-bullhorn",
            type: "sub",
            children: [
              {
                title:"Aha Moment",
                path:`${process.env.PUBLIC_URL}/pages/aha-moment`,
                type:"link"
              },
            ]
          },
          {
            title: "Sales",
            icon: "fa-line-chart",
            type: "sub",
            children: [
              {
                // Read each time the sidebar draws: "My Performance" for a sales
                // agent, "Performance" for everyone else (see currentSalesRole).
                get title() {
                  return currentSalesRole() === "SALES_AGENT" ? "My Performance" : "Performance";
                },
                path: `${process.env.PUBLIC_URL}/pages/sales-agent-performance`,
                type: "link",
              },
              {
                title:"Transactions",
                path:`${process.env.PUBLIC_URL}/pages/transactions`,
                type:"link"
              },
              {
                title: "Split Payment",
                path: `${process.env.PUBLIC_URL}/pages/split-payment`,
                type: "link",
              },
              {
                title: "Sales Agents",
                path: `${process.env.PUBLIC_URL}/pages/sales-agents`,
                type: "link",
              },
              {
                title: "Targets & Incentives",
                path: `${process.env.PUBLIC_URL}/pages/sales-targets`,
                type: "link",
              },
            ]
          },

      {
        title: "Telephony",
        icon: "fa-phone",
        type: "sub",
        children: [
          // Dialer deliberately unlisted — the floating bubble opens the dock,
          // and /pages/telephony-dialer stays routable for dial links.
          {
            title: "Agents",
            path: `${process.env.PUBLIC_URL}/pages/telephony-agents`,
            type: "link",
          },
          {
            title: "Logs",
            path: `${process.env.PUBLIC_URL}/pages/telephony-logs`,
            type: "link",
          },
          {
            title: "Analytics",
            path: `${process.env.PUBLIC_URL}/pages/telephony-analytics`,
            type: "link",
          },
          {
            title: "Phone Numbers",
            path: `${process.env.PUBLIC_URL}/pages/telephony-numbers`,
            type: "link",
          },
          {
            title: "Teams",
            path: `${process.env.PUBLIC_URL}/pages/telephony-teams`,
            type: "link",
          },
          {
            title: "Countries",
            path: `${process.env.PUBLIC_URL}/pages/telephony-countries`,
            type: "link",
          },
        ],
      },

        ]
    },
]
  